import { css } from 'lit';

export const style = css`
  /* stylelint-disable-next-line selector-id-pattern */
  #qualificationModal {
    margin-bottom: 0.5em;
  }

  .qualification-modal-body-text {
    text-align: left;
  }

  fs-body-text {
    margin-bottom: 1em;
    text-align: left;
  }
`;
